
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from '../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect , handleNotificationAlertCatch } from "../../../components/method/handleNotificationAlert";

export const actionTypes = {
    clubmemberCustomerKycProfileSelect: "[clubmemberCustomerKycProfileSelect] Action",
    clubmemberCustomerKycProfileSelectAsync: "[clubmemberCustomerKycProfileSelectAsync] Action",
    clubmemberCustomerKycProfileRemove: "[clubmemberCustomerKycProfileRemove] Action",
    clubmemberCustomerKycProfileLoading: "[clubmemberCustomerKycProfileLoading] Action",
    clubmemberCustomerKycOmsFlag: "[clubmemberCustomerKycOmsFlag] Action",
};

const initialState = {
    data: {},
    isOk: false,
    loading:false,
    flag:false
};


export const reducer_customer_get_kyc_profile = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.clubmemberCustomerKycProfileSelect:
            return {
                ...state,
                data: payload,
                isOk: true
            }
            case actionTypes.clubmemberCustomerKycProfileLoading:
            return {
                ...state,
                loading: payload,
            }
            case actionTypes.clubmemberCustomerKycOmsFlag:
            return {
                ...state,
                flag: payload,
            }
            case actionTypes.clubmemberCustomerKycProfileRemove:
                return initialState
            default:
                return state
    }
}

function* handleWorker({ payload }) {
    
    yield put({ type: actionTypes.clubmemberCustomerKycProfileLoading, payload:true })
    let config = {
        url: "update_request",
    }

    let data = {
        table: "clubmember",
        method_type: "sync_from_sejam",
        data: payload ? payload : {}
    } 


    try {
        let res = yield axiosCustom(config, data)

        let isOk = handleNotificationAlertTrySelect(res)
        if (!isOk) return

        yield put({ type: actionTypes.clubmemberCustomerKycProfileSelect, payload: res?.data?.response?.data?.sejam_data })


    } catch  {
        handleNotificationAlertCatch()
    }
    finally{
        yield put({ type: actionTypes.clubmemberCustomerKycProfileLoading, payload:false })
    }


}


export function*  worker_customer_get_kyc_profile () {

    yield takeLatest(actionTypes.clubmemberCustomerKycProfileSelectAsync, handleWorker)
}